<div class="section-card">
    <h6 class="section-title">
        <i class="bi bi-tags me-2"></i>
        Tipos de productos
    </h6>
    <div class="type-list">
        <button
            *ngFor="let tipo of tipos"
            type="button"
            class="type-item"
            [class.active]="tiposSeleccionados.includes(tipo)"
            (click)="tipoSeleccionado.emit(tipo)">
            <div class="d-flex align-items-center">
                <i
                    class="bi bi-circle-fill me-2"
                    [style.color]="getTipoColor(tipo.id)"></i>
                <span>{{ tipo.nombre }}</span>
            </div>
            <i
                class="bi bi-check-lg check-icon"
                *ngIf="tiposSeleccionados.includes(tipo)"></i>
        </button>
    </div>
</div>
